import { PortfolioTopBottomItem, PortfolioTopBottomResponse } from "components/molecules/portfolio/PortfolioTopSection";
import { KeyNumbers } from "interfaces/transaction/transaction";

const TABLE_SIZE = 10;

export const getAccsessorNumberOfTransaction = (sortValue: string) => {
  switch (sortValue) {
    case "RATE_AMOUNT_EVOLUTION_WEEK":
    case "RATE_VOLUME_EVOLUTION_WEEK":
      return "volumeEvolutionWeek";
    case "RATE_AMOUNT_EVOLUTION_MONTH":
    case "RATE_VOLUME_EVOLUTION_MONTH":
      return "volumeEvolutionMonth";
    default:
      return "volumeEvolutionDay";
  }
};
export const getAccsessorGrossAmount = (sortValue: string) => {
  switch (sortValue) {
    case "RATE_AMOUNT_EVOLUTION_WEEK":
    case "RATE_VOLUME_EVOLUTION_WEEK":
      return "amountEvolutionWeek";
    case "RATE_AMOUNT_EVOLUTION_MONTH":
    case "RATE_VOLUME_EVOLUTION_MONTH":
      return "amountEvolutionMonth";
    default:
      return "amountEvolutionDay";
  }
};

const assignIndex = (item: PortfolioTopBottomItem, idx: number): PortfolioTopBottomItem => {
  item.idx = idx;
  return item;
};

export const getTopBottomItems = (response: PortfolioTopBottomResponse): Array<PortfolioTopBottomItem> => {
  const { items, total } = response;

  if (total < TABLE_SIZE * 2) {
    return items.map((item, idx) => assignIndex(item, idx + 1));
  }
  const topResults = items.slice(0, TABLE_SIZE).map((item, idx) => assignIndex(item, idx + 1));
  const bottomResults = items.slice(-TABLE_SIZE);
  bottomResults.forEach((item, idx) => assignIndex(item, total - bottomResults.length + idx + 1));
  return [...topResults, ...bottomResults];
};

export const getTotalAmounts = (items: Array<PortfolioTopBottomItem>): KeyNumbers => {
  const totalCommition = items.reduce((sum, item) => {
    if (!item.commissionAmount) {
      return sum;
    }
    return sum + item.commissionAmount;
  }, 0);
  const distributorCommition = items.reduce((sum, item) => {
    if (!item.commissionDistribAmount) {
      return sum;
    }
    return sum + item.commissionDistribAmount;
  }, 0);

  return {
    totalCommission: totalCommition,
    totalDistributorComission: distributorCommition,
  };
};
